app.factory('mdContentService', ['$timeout', function ($timeout) {
	var service = this;

	service.triggerSyntheticScrollEvent = function() {
		$timeout(function() {
			triggerMdContentScroll();
		}, 0);
		$timeout(function() {
			triggerMdContentScroll();
		}, 10);
		$timeout(function() {
			triggerMdContentScroll();
		}, 25);
		$timeout(function() {
			triggerMdContentScroll();
		}, 50);
		$timeout(function() {
			triggerMdContentScroll();
		}, 100);
	}

	return service;
}]);